import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import WaterLocationTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import WaterSymbioticlEquipmentContents from "../WaterEquipment/WaterSymbiotic";
import symbioticWaterIcon from "../../../../../assets/design-revamp-company/category-icons/symbiotic_water_icon.svg";
const WaterSymbioticInputContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("WATER_SYMBIOTIC_INPUT")}
        subDescription={t("WATER_SYMBIOTIC_INPUT_DESC")}
        isNormal={true}
        number={"2.4.3"}
        icon={symbioticWaterIcon}
      />

      {showTable && (
        <WaterLocationTable
          businessId={businessId}
          category="symbiotic"
          subcategory="non_equipment_symbiotic"
        />
      )}
      {showTable && (
        <WaterSymbioticlEquipmentContents businessId={businessId} />
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default WaterSymbioticInputContents;
